import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';



import * as moment from 'moment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportDownloadService } from './report.download.service';
import { BindComponentService } from '../utils/bind.component.service';
import { ProcessAsyncReport } from '../models/reports.process.asynchronous.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: reports.operations.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */
@Injectable()
export class ProcAsyncReportService extends CommonService  {

  private localURL: string;
  private REPORTS_DOWNLOAD_PATH:string = '/datapackreportsdownload';
  private REPORTS_PATH:string = '/datapackreports';
  private localDownloadURL:string;
  private account: string;
  private operations: ProcessAsyncReport[] = [];

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService, public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.REPORTS_PATH;
    this.localDownloadURL = this.baseURL + this.REPORTS_DOWNLOAD_PATH;
  }

  public convertResponse(response: Observable<Response>) {
    return response
      .map((res: Response) => {
        this.operations = res.json();
        return this.operations;
      })
      .catch((err: Response) => Observable.throw(err.json ? err.json() : err) );
  }

  public listProcAsyncOperations() {
    let data = JSON.parse(localStorage.getItem('GET_AUTENTICATED_USER'));
    this.account = data['account'];
    let url = this.localURL + '?action=listProcAsyncOperations';
    url += '&externalId=' + this.account;
    return this.convertResponse(this.httpGet(url));
  }

  public generateReport(externalid: string, startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=exportProcAsyncReport';
    url += '&externalId=' + externalid;
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    } 
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    
	  this.reportDownloadService.prepare(url);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/reports.procasync.service.ts